module.exports = __webpack_public_path__ + "img/hatchet.1d09c2cf.png";